var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app_detail_tab2"
  }, [_c('div', {
    staticClass: "box_contain"
  }, [_c('pro-form', {
    ref: "yypz",
    attrs: {
      "labelWidth": 200,
      "columns": _vm._config
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('div', {
    staticClass: "save"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.yypzChange
    }
  }, [_vm._v($t("e32z2", "保存"))])], 1)], 1), _c('div', {
    staticClass: "line"
  }), _c('div', {
    staticClass: "progress"
  }, [_vm._isThirdDingDing ? _c('img', {
    attrs: {
      "src": require("../../../../assets/pingzheng.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../../assets/qiyewx.png")
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };